// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/ApprovalPolicy.yaml
// Generated: 2026-02-28T16:35:54.978Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateApprovalPolicy, UpdateApprovalPolicy, ApprovalPolicy } from '@/types/workflow/ApprovalPolicy';

/**
 * ApprovalPolicy Service
 * CRUD operations for ApprovalPolicy via the ABP API.
 */
export const approvalPolicyService = new EntityService<ApprovalPolicy, CreateApprovalPolicy, UpdateApprovalPolicy>(
  '/api/workflow/approvalpolicy',
  'ApprovalPolicy',
);
